var React = require('react');

function DownChevronLarge (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.3 7c-.4-.4-1-.4-1.4 0L12 14.9 4.1 7c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l8.6 8.6c.4.4 1 .4 1.4 0l8.6-8.6c.4-.4.4-1 0-1.4z"}));
}

DownChevronLarge.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = DownChevronLarge;

DownChevronLarge.default = DownChevronLarge;
